import { z } from 'zod';

export const themeSchema = z.enum(['light', 'dark']);

export type Theme = z.infer<typeof themeSchema>;

/** The default theme to be used when none is specified. */
export const DEFAULT_THEME: Theme = 'dark';

/**
 * List of URL path prefixes that should use the dark theme.
 * Paths in this array will trigger a dark theme when detected.
 */
const DARK_THEME_URLS = ['/play'];

/**
 * Determines whether a given URL should be rendered using the dark theme.
 *
 * This function attempts to parse the input string as a URL, extracts its pathname,
 * and checks if that pathname starts with any of the prefixes in `DARK_THEME_URLS`.
 *
 * If the URL cannot be parsed or the pathname does not start with any of the prefixes,
 * the function returns `false`.
 */
export const isDarkUrl = (url: string) => {
  try {
    const path = new URL(url).pathname;
    return DARK_THEME_URLS.some((url) => path.startsWith(url));
  } catch {
    return false;
  }
};
